"use strict";

var moduleName = "clipboard";

var clipboard = require("clipboard");

module.exports = function () {
	$(".jsBtnCopyLink").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);

		new clipboard(this);
	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/clipboardInit.js
 **/